import { render, staticRenderFns } from "./LoginChallenge.vue?vue&type=template&id=9ff8d9c0"
import script from "./LoginChallenge.vue?vue&type=script&lang=js"
export * from "./LoginChallenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports